import { GET_FilterSearch_FAILD, GET_FilterSearch_LOADING, GET_FilterSearch_SUCCESS, Remove_FilterSearch } from "../types";

const initialState = {
  loading: false,
  error: null,
  FilterSearchList: null,
};

export const getListOfFilterSearchReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_FilterSearch_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_FilterSearch_SUCCESS:
      return {
        ...state,
        loading: false,
        FilterSearchList: action.payload,
        error: null,
      };
    case GET_FilterSearch_FAILD:
      return {
        ...state,
        loading: false,
        currencyList: null,
        error: action.error,
      };
    case Remove_FilterSearch:
      return initialState;
    default:
      return state;
  }
};


